import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const AUTHENTICATION = 'authentication';

export const selectAuthState = createFeatureSelector<AuthState>(AUTHENTICATION);

export const selectLoggedIn = createSelector(selectAuthState, (state) => state.isLoggedIn);
export const selectAuthInitialising = createSelector(selectAuthState, (state) => state.initialising);
export const selectIsShopper = createSelector(selectAuthState, (state) => state.isShopper);
